export default __webpack_public_path__ + "static/media/resto.d41705f4.svg";